<template>
  <div class="password-reset">
    <h1>Reset password</h1>
    <p v-if="!token">This reset link is missing a token. Ask for a new link from the sign-in form.</p>
    <b-form v-else-if="!done" @submit="onSubmit">
      <p v-if="ruleSummary" class="text-muted">{{ ruleSummary }}</p>
      <b-form-group label="New password" label-for="reset-password">
        <b-form-input id="reset-password" type="password" v-model="password" autocomplete="new-password" />
      </b-form-group>
      <b-form-group label="Confirm password" label-for="reset-password-confirm">
        <b-form-input id="reset-password-confirm" type="password" v-model="confirm" autocomplete="new-password" />
      </b-form-group>
      <b-button type="submit" variant="primary" :disabled="busy">{{ busy ? 'Saving…' : 'Save password' }}</b-button>
      <div v-if="error" class="text-danger mt-2" role="alert">{{ error }}</div>
    </b-form>
    <p v-else role="status">Password saved. <router-link :to="{ path: '/' + $route.params.application }">Back to the app</router-link></p>
  </div>
</template>

<script>
  import axios from 'axios'
  import { passwordPolicyForRead, passwordRuleSummary } from '../../../shared/password-policy.js'

  export default {
    data () {

      return {
        password: '',
        confirm: '',
        busy: false,
        done: false,
        error: '',
        passwordPolicy: passwordPolicyForRead(null)
      }
    },
    computed: {
      token () {

        return this.$route.query.token || ''
      },
      ruleSummary () {

        return passwordRuleSummary(this.passwordPolicy)
      }
    },
    async mounted () {

      try {

        const res = await axios.get(`${VUE_APP_PROXY_SERVER_URL}/${this.routeAccount}/${this.$route.params.application}/settings`)

        this.passwordPolicy = passwordPolicyForRead(res.data && res.data.passwordPolicy)
      } catch (err) {

        this.passwordPolicy = passwordPolicyForRead(null)
      }
    },
    methods: {
      async onSubmit (event) {

        event.preventDefault()
        if (this.busy) return

        this.error = ''

        if (this.password !== this.confirm) {
          this.error = 'Those passwords do not match.'
          return
        }

        this.busy = true

        try {

          await axios.post(`${VUE_APP_PROXY_SERVER_URL}/${this.routeAccount}/${this.$route.params.application}/password/reset`, {
            token: this.token,
            password: this.password
          })
          this.done = true
        } catch (err) {

          const data = err.response && err.response.data

          this.error = (data && data.error) || 'The password could not be saved.'
        } finally {

          this.busy = false
        }
      }
    }
  }
</script>

<style scoped>
.password-reset {
  max-width: 28rem;
  margin: 2rem auto;
  text-align: left;
}

.password-reset h1 {
  color: inherit;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}
</style>
